module.exports = __webpack_public_path__ + "img/40_70_001_742.06f96e23.jpg";